import { createContext } from "react";

const AuthContext = createContext();
const LoadingContext = createContext();
const ModalContext = createContext();

export { AuthContext, LoadingContext, ModalContext };
